/* Static owner-maintained display figures. No network or business-data access. */
(() => {
  'use strict';
  if (customElements.get('pt-homepage-counter')) return;

  customElements.define('pt-homepage-counter', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => { if (this.motion.matches) this.stop(); };
      this.motion.addEventListener('change', this.onMotionChange);
      if (this.motion.matches || this.dataset.animate !== 'true') return;
      if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.animate();
        }
      }, { threshold: 0.1 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      if (this.motion && this.onMotionChange) this.motion.removeEventListener('change', this.onMotionChange);
    }

    stop() {
      if (this.observer) this.observer.disconnect();
      if (this.frame) window.cancelAnimationFrame(this.frame);
      this.frame = null;
      this.querySelectorAll('[data-counter-value]').forEach(node => node.classList.remove('is-counting'));
    }

    animate() {
      if (this.motion.matches) return;
      const duration = Math.min(4000, Math.max(200, Number(this.dataset.duration) || 2000));
      const format = new Intl.NumberFormat('en-AU', { maximumFractionDigits: 0 });
      const counters = [...this.querySelectorAll('[data-counter-value]')].map(node => ({
        node, value: Number(node.dataset.counterValue),
        moving: node.querySelector('[data-counter-moving]')
      })).filter(item => Number.isSafeInteger(item.value) && item.value >= 0 && item.moving);
      // Final values always remain in the DOM and accessibility tree. The animated
      // overlay is aria-hidden, and reserves the same space as the final number.
      counters.forEach(item => {
        item.moving.textContent = format.format(0);
        item.node.classList.add('is-counting');
      });
      let start;
      const tick = now => {
        if (!this.isConnected || this.motion.matches) { this.stop(); return; }
        if (start === undefined) start = now;
        const progress = Math.min(1, Math.max(0, (now - start) / duration));
        const eased = 1 - Math.pow(1 - progress, 3);
        counters.forEach(item => { item.moving.textContent = format.format(Math.floor(item.value * eased)); });
        if (progress < 1) this.frame = window.requestAnimationFrame(tick);
        else this.stop();
      };
      this.frame = window.requestAnimationFrame(tick);
    }
  });
})();
